import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const searchBikesByReg = async (value) => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_BRANDS}?filterByName=${value}&limit=10`,
        });
        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: e.message,
            error: e,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/requests/search_by_reg_request.js